
import React from "react";
import styled from 'styled-components';
import logoWhiteHorizontal from '../../../static/horizontal-logo-white.svg';
import logoWhiteVertical from '../../../static/vertical-logo-white.svg';

const Image = styled.img`
  transform: translateY(-3px);
`;

const LogoWhite = (props) => {
  return (
    props.vertical ? 
      <Image src={logoWhiteVertical} alt="Logo White" width={props.width}/>
      :
      <Image src={logoWhiteHorizontal} alt="Logo White" width="145" height="80" />
  )
}

export default LogoWhite;
